export class PipelineSettingsTrackers {
  static readonly PIPELINE_TRACKER_PIPELINE_SETTINGS_SAVE_CLICK =
    '[Pipelines] pipeline settings save click';

  static readonly PIPELINE_TRACKER_PIPELINE_SETTINGS_SAVE = '[Pipelines] pipeline settings save';

  static readonly PIPELINE_TRACKER_PIPELINE_SETTINGS_SAVE_SUCCESS =
    '[Pipelines] pipeline settings save success';

  static readonly PIPELINE_TRACKER_PIPELINE_SETTINGS_SAVE_FAILURE =
    '[Pipelines] pipeline settings save failure';

  static readonly PIPELINE_TRACKER_PIPELINE_SETTINGS_VALIDATION_FAILURE =
    '[Pipelines] pipeline settings validation failure';

  static readonly PIPELINE_TRACKER_PIPELINE_SETTINGS_ERROR_MODE_CHANGE =
    '[Pipelines] pipeline settings error mode change';

  static readonly PIPELINE_TRACKER_PIPELINE_SETTINGS_LOAD_MODE_CHANGE =
    '[Pipelines] pipeline settings load mode change';

  static readonly PIPELINE_TRACKER_PIPELINE_SETTINGS_SCHEMA_EVOLUTION_POLICY_CHANGE =
    '[Pipelines] pipeline settings schema evolution policy change';

  static readonly PIPELINE_TRACKER_PIPELINE_SETTINGS_DESTINATION_TABLE_SETTINGS_CHANGE =
    '[Pipelines] pipeline settings destination table settings change';
}
